/**
 * ajax request help
 */

import axios from 'axios'
import cache from './cache'
import rest from '../rest'
import util from './util'
import url from './url'

const qs = require('qs')

class Ajax {
  constructor(options) {
    this.$http = axios
    this.baseUrl = options && options.baseUrl ? options.baseUrl : '/api/v1'
    this.authUrl = options && options.authUrl ? options.authUrl : '/auth/weixin'
    this.options = options
    axios.defaults.headers.common.channelType = 'wx'
    // 后端请求默认不支持json格式的数据
    // TODO: 下面两行不生效，原因未知，相同功能的逻辑在formatOptions函数中处理
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.defaults.withCredentials = false

    const newfromId = url.getSearch()._from_corp_id || ''
    const oldFromId = cache.getSessionData('formId')
    const fromId = newfromId || oldFromId

    if (newfromId && (oldFromId !== newfromId)) {
      cache.setSessionData('formId', newfromId)
    }
    if (fromId) {
      axios.defaults.headers.common['DOS-GROUP-CORP-ID'] = fromId
    }

    const storeId = url.getSearch()._from_store_id || ''
    if (storeId) {
      axios.defaults.headers.common['DOS-STORE-ID'] = storeId
    }

    const fromAgent = url.getSearch()._from_agent || cache.getSessionData('DOS-FROM-AGENT')
    if (fromAgent) {
      // 缓存数据，避免路由切换后 URL参数丢失
      cache.setSessionData('DOS-FROM-AGENT', fromAgent)
      axios.defaults.headers.common['DOS-FROM-AGENT'] = fromAgent
    }

    // TODO: nedd check 'credentials' 是否是跨域属性
    // 拦截器，一些跨域的请求添加csrftoken
    axios.interceptors.request.use(
      config => {
        const accessToken = cache.getSessionData('access_token')
        if (accessToken) {
          config.headers['access-token'] = accessToken
        }
        return config
      },
      err => Promise.reject(err)
    )
    // ajax 全局错误处理(vue-resource 拦截器)
    axios.interceptors.response.use(
      response => {
        this.success && this.success(response)
        return response
      },
      err => {
        if (err.response) {
          const status = +err.response.status
          // 处理状态码错误
          switch (status) {
            case 404:
              util.showToast('请求发生404错误!')
              break
            case 500:
              util.showToast('请求发生500错误!')
              break
            case 504:
              util.showToast('请求超时')
              break
            case 401:
              this.redirect()
              break
            default:
              util.showToast(`未处理请求的状态res.status:${res.status}`)
          }
          return Promise.reject(err)
        }
      }
    )
  }
  async redirect() {
    // 登录状态处理
    if (cache.getSessionData('hasLogin')) return
    cache.setSessionData('hasLogin', 1)

    const now = Date.now()
    let next = ('?from=wx_' + now) + (window.location.hash || '#/cus_day')
    const chooseStoreNext = encodeURIComponent(`#/choose_store?next=${next}`)
    next = encodeURIComponent(next)

    const res = await rest.auth.getWeixinUrl({
      next: next,
      choose_store_next: chooseStoreNext,
      api: true
    })

    if (res.status === 404) {
      util.showToast('404错误')
      return
    }

    if (res.code !== 0) {
      util.showToast(res.message)
      return
    }

    // let weixinUrl = res.data.url
    window.location.href = res.data.url
  }

  parse(path, id) {
    if (typeof id === 'string') {
      return path + '/' + 'id'
    }
    if (typeof id === 'object') {
      let search = '?'
      let counter = 0
      for (let key in id) {
        if (counter) search += '&'
        search += key + '=' + id[key]
        counter++
      }
      return path + search
    }
    return path
  }

  formatOptions(options) {
    const opts = options || {}
    const contentType = opts.useJsonData ? 'application/json' : 'application/x-www-form-urlencoded'
    return {
      ...opts,
      headers: {
        ...(opts.headers || {}),
        'content-type': contentType
      }
    }
  }

  query(path, options = {}) {
    return (id, expand) => {
      const expandedPath = expand ? `${path}/${expand}` : path
      const newPath = id ? this.parse(expandedPath, id) : expandedPath
      const opts = { ...this.options, ...options }
      const pathUrl = `${(opts.customUrl || this.baseUrl)}${newPath}`
      return this.$http.get(pathUrl, options)
        .then((res) => {
          return res.data
        })
        .catch(err => {
          const url = ((err || {}).config || {}).url
          window.console.error(`${url}::ajax请求错误`, JSON.stringify(err.response))
        })
    }
  }
  // 增
  create(path, options = {}) {
    return (data, expand) => {
      const expandedPath = expand ? `${path}/${expand}` : path
      const opts = this.formatOptions(options)
      const _data = opts.useJsonData ? data : qs.stringify(data)
      const pathUrl = `${(opts.customUrl || this.baseUrl)}${expandedPath}`
      return this.$http.post(pathUrl, _data, opts)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          const url = ((err || {}).config || {}).url
          window.console.error(`${url}::ajax请求错误`, JSON.stringify(err.response))
        })
    }
  }
  // put 方法~
  putWay(path, options = {}) {
    return (data, expand) => {
      const expandedPath = expand ? `${path}/${expand}` : path
      const opts = this.formatOptions(options)
      const _data = opts.useJsonData ? data : qs.stringify(data)
      const pathUrl = `${(opts.customUrl || this.baseUrl)}${expandedPath}`
      return this.$http.put(pathUrl, _data, opts)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          const url = ((err || {}).config || {}).url
          window.console.error(`${url}::ajax请求错误`, JSON.stringify(err.response))
        })
    }
  }
  // patch 方法~
  patch(path, options = {}) {
    return (data, expand) => {
      const expandedPath = expand ? `${path}/${expand}` : path
      const opts = this.formatOptions(options)
      const _data = opts.useJsonData ? data : qs.stringify(data)
      const pathUrl = `${(opts.customUrl || this.baseUrl)}${expandedPath}`
      return this.$http.patch(pathUrl, _data, opts)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          const url = ((err || {}).config || {}).url
          window.console.error(`${url}::ajax请求错误`, JSON.stringify(err.response))
        })
    }
  }
  // delete 方法~
  delete(path) {
    return (data, expand) => {
      const expandedPath = expand ? `${path}/${expand}` : path
      const pathUrl = `${this.baseUrl}${expandedPath}`
      return this.$http.delete(pathUrl, data)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          const url = ((err || {}).config || {}).url
          window.console.error(`${url}::ajax请求错误`, JSON.stringify(err.response))
        })
    }
  }
}
export default new Ajax()
